import { useEffect, useRef } from "react";

/**
 * Barre de progression de lecture, fixée juste sous la barre de menu (56 px sur téléphone, 64 px sur ordinateur).
 * color : "violet" (analyses), "orange" (cours) ou "emerald".
 * 0 % en haut de la page, 100 % quand la fin de l'élément ciblé (le corps de l'article) est visible.
 */
export default function ReadingProgress({ targetRef, color = "emerald" }) {
  const COLORS = {
    orange: ["bg-orange-400", "0 0 10px rgba(247,152,55,.6)"],
    violet: ["bg-violet-400", "0 0 10px rgba(177,117,255,.6)"],
    emerald: ["bg-emerald-500", "0 0 10px rgba(0,191,99,.7)"],
  };
  const [bg, glow] = COLORS[color] || COLORS.emerald;
  const barRef = useRef(null);

  useEffect(() => {
    let raf = 0;
    const update = () => {
      raf = 0;
      const el = targetRef?.current;
      const bar = barRef.current;
      if (!el || !bar) return;
      const end = el.getBoundingClientRect().bottom + window.scrollY - window.innerHeight;
      const done = Math.min(1, Math.max(0, window.scrollY / Math.max(1, end)));
      bar.style.transform = `scaleX(${done})`;
    };
    const onScroll = () => { if (!raf) raf = requestAnimationFrame(update); };
    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, [targetRef]);

  return (
    <div className="fixed left-0 right-0 top-14 md:top-16 z-[60] h-[3px] bg-white/5 pointer-events-none" aria-hidden="true">
      <div
        ref={barRef}
        className={`h-full origin-left transition-transform duration-150 ease-out ${bg}`}
        style={{ transform: "scaleX(0)", boxShadow: glow }}
      />
    </div>
  );
}
